import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './edit-panel-view-template.pug';

export const getEditPanelView = ({ i18n }) => {
  if (!i18n) {
    return {};
  }
  /**
   * Shared view for Hotel Ads edit panel
   * @extends DeterministicView
   */
  class EditPanelView extends DeterministicView {
    initialize() {
      this.i18n = i18n;
      this.model.set({ hasCleanButton: false });
      this.model.set({ isSaveButtonDisabled: false });
    }

    get template() {
      return template;
    }

    get events() {
      return {
        'click #Cancel': this.onCancel,
        'click #Save': this.onSave,
        'click #Clean': this.onClean,
      };
    }
    getState() {
      return {
        isSaveButtonDisabled: this.model.get('isSaveButtonDisabled'),
        hasCleanButton: this.model.get('hasCleanButton'),
      };
    }

    onCancel() {
      this.trigger('canceled');
    }

    onSave() {
      this.trigger('saved');
    }

    onClean() {
      this.trigger('cleaned');
    }
  }

  return {
    EditPanelView,
  };
};
